export const facets = [
    { name: "status", field: "status" },
    { name: "type", field: "type" },
    { name: "created_by", field: "created_by" },
    { name: "total", field: "total" },
]

export const GENERIC_DOCUMENT_FACETS = [
    { name: "status", field: "status" },
    { name: "type", field: "type" },
    { name: "created_by", field: "created_by" },
    { name: "total", field: "total" }
]

export const GRANT_DOCUMENT_FACETS = [
    { name: "status", field: "status" },
    { name: "type", field: "type" },
    { name: "created_by", field: "created_by" },
    { name: "total", field: "total" },
    { name: "easy_grant_id", field: "properties.easygrant_id" }
]

export const REPORT_FACETS = [
    { name: "staff", field: "created_by" },
    { name: "type", field: "properties.configuration" }
]

export const REPORT_DOCUMENT_FACETS = [
    { name: "type", field: "type" },
    { name: "easygrant_id", field: "properties.easygrant_id" },
    { name: "funding_source_number", field: "properties.funding_source_number" },
    { name: "total", field: "total" },
]

export const REPORT_GENERATION_FACETS = [
    { name: "status", field: "status" },
    { name: "type", field: "type" },
    { name: "created_by", field: "created_by" },
    { name: "total", field: "total" },
    { name: "easy_grant_id", field: "properties.easygrant_id" },
    { name: "funding_cycle", field: "properties.funding_cycle" },
    { name: "year", field: "properties.year" },
    { name: "state", field: "properties.state" }
]

export const DOCUMENT_FACETS = (project: string) => {
    return project === "66c7501e81e94689570dfe1b" ? GRANT_DOCUMENT_FACETS : GENERIC_DOCUMENT_FACETS
}

export const PROGRAM_FACETS = [
    { name: "type", field: "type" }
]